import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { FiltroEditor } from "./filtro";
import { StatusCamionList } from "./list";
type Filtro = models.FiltroStatusCamion;
export interface Props {
    value: Filtro;
    onChange: (x: Filtro) => void;
}

/**Muestra un listado de los status de cajas junto con el filtro */
class StatusCamionListFiltroControlled extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                <FiltroEditor {...this.props} />
                <StatusCamionList {... this.props} />
            </div>
        )
    }
}

export const StatusCamionListFiltro = kea.makeUncontrolled<Props>("value", "onChange", { Limite: 300 })(StatusCamionListFiltroControlled) as React.ComponentClass<{}>;


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscamion/list/listfiltro.tsx